skrilla.service('profileTagService', function() {

    const tags = {
        ESPORTS_PLAYER: {title: "E-Sports Player", colour: "light-orange"},
        EX_ESPORTS_PLAYER: {title: "Ex E-Sports Player", colour: "light-orange"},
        COMPLIANCE_REVIEW: {title: "Compliance Review", colour: "light-orange"},
        RORTER: {title: "Rorter", colour: "light-yellow"},
        ARBER: {title: "Arber", colour: "light-yellow"},
        PROMO_RORTER: {title: "Promo Rorter", colour: "light-yellow"},
        SMART_CLIENT: {title: "Smart Client", colour: "dark-red"},
        VIP: {title: "VIP", colour: "light-green"},
        WATCHING: {title: "Watching", colour: "light-red"},
        POLITICALLY_EXPOSED_PERSON_AML: {title: "Politically Exposed Person - AML", colour: "chocolate"},
        HIGH_RISK_AML: {title: "High Risk - AML", colour: "crimson"},
        RSG: {title: "RSG", colour: "light-orange"},
        NEW: {title: "New user", colour: "lime"},
        TRADING_REVIEW: {title: "Ready for trading review", colour: "teal"},
        TRADING_REVIEW_UP: {title: "Trading Review UP - Promising user", colour: "gold"},
        TRADING_REVIEW_DOWN: {title: "Trading Review Down - Concerning user", colour: "brown"},
        RG_INTERVENTION: {title: "Responsible Gaming Intervention", colour: "pink"},
        WITHDRAWAL_BLOCK: {title: "Withdrawal Block", colour: "brown"},
        PROMOTION_ALLOWED: {title: "Promotion Allowed", colour: "light-green"},
        RACING_MBL: {title: "Racing MBL", colour: "dark-red"},
        NO_BONUS_CAMPAIGNS: {title: "No Bonus Campaigns", colour: "dark-red"},
        BET_CHECK_REQUIRED: {title: "Bet Check Required", colour: "dark-red"},
        VETTED: {title: "Vetted", colour: "light-blue"},
        NSER: {title: "National Self Exclusion Register", colour: "dark-red"},
    };

    function getTagsForDropdown(){
        const tagsArr = [];
        for(key in tags){
            tagsArr.push({title: tags[key].title, value: key});
        }
        return tagsArr
    }
    function getTagsForCheckboxes(){
        const obj = {};
        Object.keys(tags).forEach(tag => {
            obj[tag] = false;
        })
        obj['NO_TAG'] = false;
        return obj;
    }

    function getTag(tag){
        return tags[tag];
    }

    return {
        getTagsForDropdown: getTagsForDropdown,
        getTagsForCheckboxes: getTagsForCheckboxes,
        getTag: getTag
    };
});
